<div class="flex flex-col gap-4">
  <!-- groups conditions message / create rounds -->
  @if(tournament?.status === 'PENDING' && authService.hasRole(['admin', 'staff'])) {
    <div class="flex gap-2 items-center">
      <p-message icon="pi pi-info-circle" class="flex flex-1" [severity]="loading || checkGroupsDifference() ? 'info' : 'error'">
        {{ 'groups-conditions' | translate }}
      </p-message>
      <p-button icon="pi pi-arrow-right" class="add-button mr-4" rounded (click)="createRounds($event)"
        [pTooltip]="'button.generate-rounds' | translate" tooltipEvent="hover" tooltipPosition="top"
        [disabled]="!(groups.length && checkGroupsDifference())" [ngClass]="{'blink': groups.length && checkGroupsDifference()}" />
    </div>
  }
  <!-- groups -->
  <div class="groups flex gap-2 flex-wrap">
    @for(group of groups; track $index) {
      <div class="flex flex-col flex-1 gap-4" [ngClass]="{'group-error': checkGroupDifference(group)}">
        <p class="group-name">{{ group.name }}</p>
          <p-table
            #groupsTable
            [value]="group.teams || []"
            dataKey="id"
            [paginator]="false"
            [loading]="loading"
            stripedRows
          >
            <ng-template #header>
              <tr>
                <th pSortableColumn="name">{{ 'field.name' | translate }}</th>
                <th></th>
              </tr>
            </ng-template>
            <ng-template #body let-team let-expanded="expanded" let-editing="editing" let-ri="rowIndex">
              <tr style="height: 75px;" [ngClass]="{'highlight': filter() && _.includes(_.toLower(_.deburr(team.name)), filter())}">
                <!-- name -->
                <td>{{ ri + 1 }}. {{ team.name }}</td>
                <!-- actions -->
                <td>
                  <div class="flex items-center justify-end gap-2">
                    <!-- move team -->
                    @if(tournament?.status === 'PENDING' && authService.hasRole(['admin', 'staff'])) {
                      <p-button icon="pi pi-arrows-alt" rounded severity="secondary"
                        [pTooltip]="'button.move-team' | translate" tooltipEvent="hover" tooltipPosition="top"
                        (click)="toggleMoveTeamPop($event, team, group)"></p-button>
                    }
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
      </div>
    }
  </div>
</div>

<!-- move team popup -->
<p-popover #moveTeamPop>
  <div class="p-confirmpopup-content">
    <ul class="list-none p-2 m-0 flex flex-col">
      @for(group of groupsAvailable; track $index) {
        <li class="flex items-center gap-2 px-2 py-3 hover:bg-emphasis cursor-pointer rounded-border" (click)="moveGroup(group)">
          <div>
            <span class="font-medium">{{ group.name }}</span>
          </div>
        </li>
      }
    </ul>
  </div>
</p-popover>

<!-- create rounds confirm dialog -->
<p-confirmdialog #confirmGroups key="rounds-create" [style]="{'max-width': '600px'}">
  <ng-template pTemplate="content" let-message>
    <div>{{ message.message }}</div>
  </ng-template>
  <ng-template pTemplate="footer">
    <p-button [label]="'button.cancel' | translate" styleClass="p-confirmpopup-reject-button" size="small"
      severity="secondary" (click)="confirmGroups.hide()"></p-button>
    <p-button [label]="'button.generate-rounds' | translate" styleClass="p-confirmpopup-accept-button" size="small"
      (click)="confirmGroups.onAccept()"></p-button>
  </ng-template>
</p-confirmdialog>
